const EntityHome = () => import(/* webpackChunkName: "entityHome" */ '@/components/EntityHome')
const routes = [
    {
        path: '/users',
        component: EntityHome,
        meta: { breadCrumb: 'Users', entity: 'editUsers' },
        children: [
            {
                path: '',
                name: 'users',
                component: () => import('@/pages/user/List.vue'),
            },
            {
                path: ':id',
                name: 'editUser',
                component: () => import('@/pages/user/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
        ],
    },
]

export default routes
